import React, { Component } from 'react';
import FormValidator from '../component/formValidator';
import Form from '../component/Form';
import moment from 'moment';

const withFormLogic = (fieldArgs, validationRules = []) => BaseComponent =>
  class extends Component {
    state = { field: fieldArgs, wasValidated: false };

    validation = new FormValidator(validationRules);

    onChangeHandler = ({ target }) => {
      this.setState({
        field: { ...this.state.field, [target.name]: target.value }
      });
    };

    onChangeFileHandler = ({ target }) => {
      this.setState({
        field: { ...this.state.field, [target.name]: target.files[0] }
      });
    };

    onChangeHandlerWithIndex = ({ target }, index, callBack = () => { }) => {
      this.setState(
        state => {
          state.field[target.name][index] = target.value;
          return state;
        },
        () => {
          callBack()
        }
      );
    };

    onChangeProgrammatically = (name, value, callBack = () => { }) => {
      this.setState(
        {
          field: { ...this.state.field, [name]: value }
        },
        () => callBack()
      );
    };

    resetField = () => {
      this.setState({
        field: fieldArgs
      });
    };

    dateOnChange = (date, name) => {
      this.setState({
        field: {
          ...this.state.field,
          [name]: moment(date).format('YYYY-MM-DD'),
          [`${name}_value`]: date
        }
      });
    };

    reactSelectHandler = (array, { name }) => {
      if (Array.isArray(array)) {
        this.setState({
          field: {
            ...this.state.field,
            [name]: Array.isArray(array) ? this.getValue(array) : array.value,
            [`${name}_value`]: array
          }
        })
      } else {
        this.setState({
          field: {
            ...this.state.field,
            [name]: [],
            [`${name}_value`]: []
          }
        })
      }
    };

    getValue = arrayObject => {
      if (arrayObject) {
        return arrayObject.map(({ value }) => {
          return value;
        });
      } else {
        return [];
      }
    };

    fieldFilter = array => {
      const newFieldArgs = Object.keys(fieldArgs);

      return Object.keys(array)
        .filter(key => newFieldArgs.includes(key))
        .reduce((obj, key) => {
          obj[key] = array[key];
          return obj;
        }, {});
    };

    submitHandler = (validation, data, callback) => {
      if (validation.isValid) {
        callback(this.fieldFilter(data));
      } else {
        this.setState({ wasValidated: true });
      }
    };

    render() {
      const { field, wasValidated } = this.state;

      const validation = this.validation.validate(field);
      return (
        <Form wasValidated={wasValidated} validationRules={validation}>
          <BaseComponent
            onChangeHandler={this.onChangeHandler}
            onChangeHandlerWithIndex={this.onChangeHandlerWithIndex}
            onChangeProgrammatically={this.onChangeProgrammatically}
            dateOnChange={this.dateOnChange}
            reactSelectHandler={this.reactSelectHandler}
            validation={validation}
            submitHandler={this.submitHandler}
            resetField={this.resetField}
            onChangeFileHandler={this.onChangeFileHandler}
            field={field}
            {...this.props}
          />
        </Form>
      );
    }
  };

export default withFormLogic;
